import styled, { css } from 'styled-components';

// Mixin para los estilos de tamaño
const sizeStyles = css`
  ${({ $size, theme }) => {
    switch ($size) {
      case 'small':
        return css`
          // padding: ${theme.sizing.xxs};
          font-size: ${theme.sizing.sm};
          padding: 0px ${theme.sizing.xxs};
          height: ${theme.sizing.lg};
        `;
      case 'large':
        return css`
          // padding: ${theme.sizing.sm};
          font-size: ${theme.sizing.sm};
          padding: 0px ${theme.sizing.sm};
          height: ${theme.sizing.xxl};
        `;
      default:
        return css`
          // padding: ${theme.sizing.xs};
          padding: 0px ${theme.sizing.xs};
          height: ${theme.sizing.xl};
          font-size: ${theme.sizing.sm};
        `;
    }
  }}
`;

// Mixin para los estilos de variantes y estados
const variantStyles = css`
  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'disabled':
        return css`
          background-color: ${theme.fill.defaultWeak};
          border-color: ${theme.border.defaultStrong};
          color: ${theme.colors.defaultSubtle};
          cursor: not-allowed;
          opacity: 0.6;
        `;
      case 'error':
        return css`
          background-color: ${theme.fill.errorBackground};
          border-color: ${theme.border.errorMain};
          color: ${theme.colors.errorMain};
        `;
      default:
        return css`
          background-color: ${theme.fill.defaultMain};
          border-color: ${theme.border.defaultWeak};
          color: ${theme.colors.defaultMain};
          &:hover {
            background-color: ${theme.fill.defaultWeak};
            border-color: ${theme.border.defaultStrong};
          }
          &:active {
            background-color: ${theme.fill.defaultWeak};
            border-color: ${theme.border.inverseMain};
          }
          &::placeholder {
            color: ${theme.colors.defaultWeak};
          }
        `;
    }
  }}
`;

// Input estilizado
const Select = styled.select`
  width: 100%;
  border: 1px solid;
  border-radius: ${({ theme }) => theme.radius.xs};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'ss01' on, 'ss05' on, 'ss06' on, 'ss07' on;
  font-family: "MonaSans";
  font-style: normal;
  font-weight: 400;
  
  ${sizeStyles} /* Aplicar los estilos basados en el tamaño */
  ${variantStyles} /* Aplicar los estilos basados en la variante */

  -webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background: url(https://api.iconify.design/akar-icons/chevron-down.svg) no-repeat center / contain;
	background-size: 20px;
	background-position: calc(100% - 10px);

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.border.inverseMain};
  }
`;

export default Select;